var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[(_vm.isLegend)?_c('div',{staticClass:"footer__right"},[_c('div',{staticClass:"color-box"},[_vm._v(" * Все цены указаны до налога оператора ")]),_vm._l((_vm.colorBoxData),function(item,index){return _c('div',{key:index,staticClass:"color-box"},[_c('div',{staticClass:"color-box__color",class:item.class}),_c('div',{class:[
					'color-box__title', 
					item.class
				]},[_vm._v(" "+_vm._s(item.title)+" ")])])})],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }